import { Routes, Route, Navigate } from 'react-router-dom'
import { useMetaPixel } from './hooks/useMetaPixel'
import Layout from './components/Layout'
import CookieConsent from './components/CookieConsent'
import HomePage from './pages/HomePage'
import LoginPage from './pages/LoginPage'
import RegisterPage from './pages/RegisterPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import BookOfTheMonthPage from './pages/BookOfTheMonthPage'
import PersonalSubscriptionPage from './pages/PersonalSubscriptionPage'
import ThematicSubscriptionsPage from './pages/ThematicSubscriptionsPage'
import ComingSoonPage from './pages/ComingSoonPage'
import CartPage from './pages/CartPage'
import CheckoutPage from './pages/CheckoutPage'
import CheckoutSuccessPage from './pages/CheckoutSuccessPage'
import RegulaminPage from './pages/RegulaminPage'
import RodoPage from './pages/RodoPage'
import NotFoundPage from './pages/NotFoundPage'
import LibraryLayout from './components/library/LibraryLayout'
import LibraryMainPage from './pages/library/LibraryMainPage'
import LibraryComingSoonPage from './pages/library/LibraryComingSoonPage'
import LibrarySubscriptionsPage from './pages/library/LibrarySubscriptionsPage'
import LibraryBooksellerPage from './pages/library/LibraryBooksellerPage'
import LibraryProfilePage from './pages/library/LibraryProfilePage'

export default function App() {
  useMetaPixel()

  return (
    <>
      <Routes>
        {/* Auth routes — rendered without the global header */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        {/* Public site routes */}
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/subscription/book-of-the-month" element={<BookOfTheMonthPage />} />
          <Route path="/subscription/personal" element={<PersonalSubscriptionPage />} />
          <Route path="/subscriptions/thematic" element={<ThematicSubscriptionsPage />} />
          <Route path="/gifts" element={<ComingSoonPage />} />
          <Route path="/company" element={<ComingSoonPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
          <Route path="/regulamin" element={<RegulaminPage />} />
          <Route path="/rodo" element={<RodoPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>

        {/* Moja Biblioteka routes */}
        <Route path="/moja-biblioteka" element={<LibraryLayout />}>
          <Route index element={<LibraryMainPage />} />
          <Route path="historia" element={<LibraryComingSoonPage />} />
          <Route path="subskrypcje" element={<LibrarySubscriptionsPage />} />
          <Route path="ksiegarz" element={<LibraryComingSoonPage />} />
          <Route path="profil" element={<LibraryProfilePage />} />
        </Route>

        {/* Legacy portal redirect */}
        <Route path="/portal" element={<Navigate to="/moja-biblioteka" replace />} />
      </Routes>

      <CookieConsent />
    </>
  )
}
